<script>
  import Fa from 'svelte-fa';
  import { faAngleUp } from '@fortawesome/free-solid-svg-icons';
  import { links } from './stores.js';

  const toTheTop = () => {
    window.scrollTo(0, 0);
  };

  let scrollY = 0;
  let innerHeight;
  const clamp = (num, min, max) => Math.min(Math.max(num, min), max);
  const makeColorCode = (value, min, max) => {
    const clamped = clamp(value, min, max);
    return `rgba(${clamped}, ${clamped}, ${clamped})`;
  };
  const makeColorHex = (ratio) => {};
  $: scrolled =
    innerHeight - scrollY > 0 ? (innerHeight - scrollY) / innerHeight : 0;
  $: color = makeColorCode(Math.round(scrolled) * 255, 222, 255);
  $: opacity = clamp(1 - scrolled, 0, 0.8);

  const connectKakao = () => {
    window.open(links.kakao);
  };
</script>

<svelte:window bind:scrollY bind:innerHeight />

<aside>
  <span
    class="container to-top"
    on:click={toTheTop}
    style="background-color:{color}; opacity:{opacity}"
  >
    <Fa icon={faAngleUp} size="1.5x" />
  </span>

  <a class="container location" href="#location">
    <span class="location-img" />
  </a>

  <div class="container kakao" on:click={connectKakao}>
    <span class="kakao-img" />
  </div>
</aside>

<style>
  .container {
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    right: 80px;
    /* border-radius: 5%; */
    z-index: 1000;
    width: 60px;
    height: 60px;
    background-color: whitesmoke;
    border-radius: 30px;
    opacity: 1;
    transition: 0.3s;
    box-shadow: 1px 1px 3px #666;
  }
  .container:hover {
    opacity: 1;
    cursor: pointer;
    box-shadow: 2px 3px 4px #444;
  }
  .container:active {
    box-shadow: 0px 0px 0px;
    transition: 0s;
    transform: translate(2px, 3px);
  }

  .to-top {
    bottom: 230px;
  }

  .location {
    bottom: 155px;
  }
  .kakao {
    bottom: 80px;
    background-color: #f7e600;
  }
  .kakao-img {
    width: 100%;
    height: 100%;
    background-image: url('/imgs/kakaotalk.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    transform: scale(0.7);
  }

  .location-img {
    width: 100%;
    height: 100%;
    background-image: url('/imgs/marker.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    transform: scale(0.8);
  }

  @media screen and (max-width: 768px) {
    .container {
      width: 36px;
      height: 36px;
      border-radius: 18px;
      right: 20px;
    }

    .to-top {
      bottom: 130px;
    }

    .location {
      bottom: 80px;
    }
    .kakao {
      bottom: 30px;
    }
  }
</style>
